import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataShareService } from '../../../services/data-share.service';
import { AccountMembership, AccountType, APIService, UpdateAccountMembershipAction, UpdateAccountMembershipInput, User, UserStatus } from '../../API.service.custom';
import { CognitoUser } from 'app/core/auth-shim';
import { AuthService } from '../auth.service';
import { NGXLogger } from 'ngx-logger';
import { filter } from 'lodash-es'
import { ToastrService } from 'ngx-toastr';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgOptimizedImage, NgClass, TitleCasePipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-no-account',
    templateUrl: './no-account.component.html',
    styleUrls: ['./no-account.component.scss'],
    imports: [NgOptimizedImage, ExtendedModule, MatButton, MatIcon, MatProgressSpinner, RouterLink, RouterLinkActive, TitleCasePipe]
})
export class NoAccountComponent implements OnInit {

 accountsInNeedOfAcceptance : AccountMembership[] = [];
 private userId = null;
 private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();
  isLoading = true

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private userDetails_: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();
  private activeAccountMemberships: AccountMembership[] = [];
  private registeredUser: User = null;
  accountMembershipUpdateInitiated : Boolean = false

  constructor(
    private dataService: DataShareService,
    private auth: AuthService,
    private logger: NGXLogger,
    private api: APIService,
    private toastr: ToastrService,
    private router: Router
    ) { }

  ngOnInit(): void {
    this.getUserDetailsAndId();
  }

  
  public async getUserDetailsAndId() {
    this.busy_.next(true);
    this.errorMessage_.next('');
    try {
      const userDetails: CognitoUser = await this.auth.currentAuthenticatedUser();
      this.userId = userDetails.getSignInUserSession().getIdToken().payload.userId;
      if (this.userId) {
        this.getUserRegistrationDetail(this.userId);
      }
      this.userDetails_.next(userDetails);
    } catch (err) {
      this.errorMessage_.next(err.message || err);
    } finally {
      this.busy_.next(false);
    }
  }

  private getUserRegistrationDetail(userId: string) {
    this.api.GetUser(userId).then(async event => {
      this.logger.log('User Registration Detail Fetched : ', event);
      if (event) {
        this.registeredUser = event;
        this.dataService.setRegisteredUser(this.registeredUser)
        this.getuserAccountMemberships(event);
      }
    })
      .catch(e => {
        this.logger.log('error fetching user registration detail', e);
      });

  }

  private getuserAccountMemberships(user: User) {
    this.api.AccountsByUser(user.id).then(event => {
      this.logger.log('User Account Memberships Fetched : ', event);
      if (event && event.items && event.items.length > 0) {
        event.items.forEach(item => {
          item.user = user;
        });
        this.activeAccountMemberships = filter(event.items, function(o) { 
          return o.userAccountStatus == UserStatus.ACTIVE && (o.account.accountType == AccountType.TEAM || o.account.accountType == AccountType.TEAM_TRIAL);
        });
        if(this.activeAccountMemberships.length > 0)
          this.router.navigate(['/home/dashboard']);
        this.accountsInNeedOfAcceptance = filter(event.items, function (item) {
          return item.userAccountStatus == UserStatus.APPROVED;
        });
      }
      this.isLoading = false;
    })
      .catch(e => {
        this.logger.log('error fetching user account memberships', e);
        this.isLoading = false;
      });
  }

  rejectMembership(membership : AccountMembership){
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.REJECT_MEMBERSHIP
      if(membership.accountEmail == null)
        input.accountEmail = this.registeredUser.registeredEmail
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        this.logger.log('Account Membership Rejected : ', event);
        this.accountsInNeedOfAcceptance.splice(0,1)
        this.router.navigate(['/home/dashboard']);
      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Error in accepting account membership', e);
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }

  acceptMembership(membership : AccountMembership){
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.ACCEPT_MEMBERSHIP
      if(membership.accountEmail == null)
        input.accountEmail = this.registeredUser.registeredEmail
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        this.logger.log('Account Membership Accepted : ', event);
        this.accountsInNeedOfAcceptance.splice(0,1)
        this.router.navigate(['/home/dashboard'])
        .then(() => {
          window.location.reload();
        });
      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Error in accepting account membership', e);
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        this.logger.log(e.errors[_i].message);
      }
    }
  }


  createOrganzationButtonClicked(): void {
    this.router.navigate(['/setup-workspace']);
  }

}
